/* Il consenso e la sua persistenza restano gestiti da Shopify. */
document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-occelli-cookie-preferences]');
  if (!button) return;
  const error = button.parentElement.querySelector('[data-occelli-privacy-error]');
  error.hidden = true;
  button.disabled = true;
  try {
    if (typeof window.privacyBanner?.showPreferences !== 'function') {
      throw new Error('Pannello preferenze cookie Shopify non disponibile');
    }
    await window.privacyBanner.showPreferences();
  } catch (failure) {
    error.hidden = false;
    console.error('Impossibile aprire le preferenze cookie', failure);
  } finally {
    button.disabled = false;
  }
});

/* Shopify può conservare il trap di Tab dopo la revoca. A dialoghi chiusi,
   i controlli legali del footer seguono la navigazione nativa del browser. */
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Tab' || !event.target.closest('.occelli-link-legale')) return;
  const visible = (selector) => {
    const element = document.querySelector(selector);
    return element && element.getBoundingClientRect().height > 0 &&
      getComputedStyle(element).visibility !== 'hidden';
  };
  if (!visible('#shopify-pc__banner') && !visible('#shopify-pc__prefs__dialog')) {
    event.stopImmediatePropagation();
  }
}, true);
